import React, { useState, useEffect } from 'react';
import jwtDecode from 'jwt-decode';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { WaveLoading } from 'react-loadingg';

import { 
  CategoryTable,
  RegAndEditCategory,
  EditOrderCategory,
} from './components';

import { PageTitle, SimplePopup } from 'components';

// >> redux
import {
  addCategory,
  getCategories,
  updateCategory,
  deleteCategory,
  updateCategoryOrder,
} from '../../redux/actions/categories';
// <<

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
}));

const Category = (props) => {
  const classes = useStyles();

  const {
    categories,
    loading
  } = props;

  const [userId, setUserId] = useState(null);
  const [userName, setUserName] = useState(null);
  const [userRole, setUserRole] = useState(null);

  const [openDialog, setOpenDialog] = useState(false);
  const [modeRegisterDlg, setModeRegisterDlg] = useState(true);
  const [openDeleteAlert, setOpenDeleteAlert] = useState(false);
  const [openOrderDialog, setOpenOrderDialog] = useState(false);

  const [disableEditButton, setDisableEditButton] = useState(true);
  const [disableDeleteButton, setDisableDeleteButton] = useState(true);

  const [selectedCategories, setSelectedCategories] = useState([]);
  const [editCategory, setEditCategory] = useState(null);

  const handleClickOpenRegisterCategory = () => {

    setEditCategory(null);
    setModeRegisterDlg(true);
    setOpenDialog(true);

  };

  const handleClickOpenEditCategory = () => {

    if (selectedCategories.length !== 1){
      return ;
    }

    const id = selectedCategories[0];
    const selectedCategory = categories.find(category => (category.id === id));

    setEditCategory(selectedCategory);
    setModeRegisterDlg(false);
    setOpenDialog(true);
  };

  const handleClickCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleClickSaveCategory = (category) => {

    if (modeRegisterDlg) {
      const newCategory = {
        name: category.name,
        template: category.template,
        save_path: category.save_path,
        modified_user: userName,
        modified_at: new Date(),
        description: category.description,
      };
      props.addCategory(newCategory);
    }else if (!modeRegisterDlg && selectedCategories.length === 1){
      const id = selectedCategories[0];
      const newCategory = {
        id: id,
        name: category.name,
        template: category.template,
        prev_path: category.prev_path,
        save_path: category.save_path,
        modified_user: userName,
        modified_at: new Date(),
        description: category.description,
      };
      //console.log(newCategory);
      props.updateCategory(newCategory.id, newCategory);
    }
    else {
      
    }
    setOpenDialog(false);
  };

  const handleClickCloseOrderDialog = () => {
    setOpenOrderDialog(false);
  };

  const handleClickSaveCategoryOrder = (newOrderCategories) => {

    //console.log('prev order -> ');
    //console.log(newOrderCategories);

    let newOrders = newOrderCategories.map((category, index) => {
      let newOrder = category;
      newOrder.order = index;
      return newOrder;
    });

    //console.log('new order -> ');
    //console.log(newOrders);

    props.updateCategoryOrder({newOrders});
    setOpenOrderDialog(false);
  };

  
  const handleClickOpenDeleteCategory = () => {
    if (selectedCategories.length === 0){
      return ;
    }
    setOpenDeleteAlert(true);
  };

  const handleClickOpenOrderCategory = () => {
    setOpenOrderDialog(true);
  };

  const handleClickDeleteAlertOk = () => {
    if (selectedCategories.length === 0){
      return ;
    }

    const deletes = selectedCategories.map((selected)=>{
      return categories.find(category => (category.id === selected));
    });

    props.deleteCategory(deletes);

    setOpenDeleteAlert(false);
  }
  
  const handleClickCloseDeleteCategory = () => {
    setOpenDeleteAlert(false);
  };

  const handleSetSelectedCategories = (checks) => {
    setSelectedCategories(checks);
  }

  useEffect(() => {
    //console.log("componentDidMount");
    props.getCategories();

    const jwt = localStorage.getItem('jwt');
    //console.log(''+jwt);

    if (jwt) {
      const decoded = jwtDecode(jwt);

      if (decoded.userid !== null) {
        setUserId(decoded.userid);
      }
      if (decoded.name !== null) {
        setUserName(decoded.name);
      }
      if (decoded.role !== null) {
        setUserRole(decoded.role);
      }
    }

    return () => {
      //console.log("componentDidUnmount");
    };
  }, []); // empty-array means don't watch for any updates

  useEffect(() => {
 
    setDisableEditButton(selectedCategories.length !== 1);
    setDisableDeleteButton(selectedCategories.length < 1);

  }, [selectedCategories]);

  if (loading) {
    return <WaveLoading />;
  }

  return (
    <div className={classes.root}>

      <PageTitle 
        pageTitle={'카테고리 현황'}
      />

      <div className={classes.content}>
        <CategoryTable 
          userRole={userRole}
          categories={categories} 
          onSetSelectedCategories={handleSetSelectedCategories}

          onClickOpenRegisterDialog={handleClickOpenRegisterCategory}
          onClickOpenEditDialog={handleClickOpenEditCategory}
          onClickOpenDeleteDialog={handleClickOpenDeleteCategory}
          onClickOpenOrderDialog={handleClickOpenOrderCategory}
          disableEditButton={disableEditButton}
          disableDeleteButton={disableDeleteButton}

          />
      </div>

      <RegAndEditCategory 
        openDialog={openDialog}
        onClickCloseDialog={handleClickCloseDialog}
        onClickSaveDialog={handleClickSaveCategory}
        editCategory={editCategory}
        modeRegisterDlg={modeRegisterDlg}
        />

      <EditOrderCategory 
        openDialog={openOrderDialog}
        onClickCloseDialog={handleClickCloseOrderDialog}
        onClickSaveDialog={handleClickSaveCategoryOrder}
        categories={categories}
        />

      <SimplePopup
        title={`삭제하시겠습니까?`} 
        openPopup={openDeleteAlert} 
        onClickClose={handleClickCloseDeleteCategory} 
        onClickOk={handleClickDeleteAlertOk}
        />
    </div>
  );
};

Category.propTypes = {
  loading: PropTypes.bool,
  categories: PropTypes.arrayOf(PropTypes.object),
};

Category.defaultProps = {
  loading: false,
  categories: [],
};

const mapStateToProps = state => ({
  loading: state.categories.loading,
  categories: state.categories.categoriesList,
});

const mapDispatchToProps = dispatch => ({
  getCategories: () => {getCategories(dispatch)},
  addCategory: (category) => {addCategory(category, dispatch)},
  updateCategory: (id, category) => {updateCategory(id, category, dispatch)},
  deleteCategory: (ids) => {deleteCategory(ids, dispatch)},

  updateCategoryOrder: (newOrderCategories) => {updateCategoryOrder(newOrderCategories, dispatch)},
})


export default connect(
  mapStateToProps,
  mapDispatchToProps,
  // {
  //   getCategories,
  //   addCategory,
  //   updateCategory,
  //   deleteCategory,
  // }
)(Category);

//export default Advertise;
